import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Helper } from 'app/common/helper';
import { Constant } from 'app/config/constants';
import { CommonTable } from 'app/model/entity/commonTable';
import { CommonTableService } from 'app/service/common-table.service';
import { CommonService } from 'app/service/common.service';
import { DialogService } from 'app/service/dialog.service';
import moment from 'moment';
@Component({
  selector: 'dialog-change-date-line',
  templateUrl: './dialog-change-date-line.component.html',
  styleUrls: ['./dialog-change-date-line.component.scss']
})
export class DialogChangeDateLineComponent implements OnInit {
  languageKey: string;
  config: any;
  commonTable: CommonTable;
  timeDateLine: any;
  helper: Helper;

  constructor(
    private dialogRef: MatDialogRef<DialogChangeDateLineComponent>,
    private commonService: CommonService,
    private translateService: TranslateService,
    private commonTableService: CommonTableService,
    private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    this.languageKey = this.commonService.getCommonObject().setting?.language;
    this.commonTable = this.data.commonTable;
    const timeDateLine = this.commonTable.value ?? Constant.TIME_DATE_LINE_DEFAULT;
    this.timeDateLine = moment(timeDateLine, Constant.FORMAT_TIME_TO_MINUTES);
    setTimeout(() => {
      this.updateConfig();
      Helper.customizeTimePicker(this.languageKey);
    });
  }

  /**
   * save information time date line
   */
  public save(): void {
    this.commonTable.value = JSON.stringify(moment(this.timeDateLine).format(Constant.FORMAT_TIME_TO_MINUTES));
    this.commonTableService
      .save(this.commonTable)
      .toPromise()
      .then(() => this.dialogRef.close(this.commonTable.value))
      .catch(error => Helper.handleError(error, this.translateService, this.dialogService));
  }

  /**
   * update config for picker
   *
   */
  private updateConfig(): void {
    this.config = {
      locale: Helper.getLocale(this.languageKey)
    };
  }
}

export interface DialogData {
  commonTable: CommonTable;
}
